import { createSlice } from '@reduxjs/toolkit';
import { api } from 'store/api';

const initialState = {
  user: {
    token: '',
    email: '',
    signInMethod: '',
  },
  isLoading: true,
};

export const authSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    saveUser: (state, action) => {
      state.user = action.payload;
      state.isLoading = false;
    },
    updateUserToken: (state, action) => {
      // return {
      //   ...state,
      //   user: {
      //     ...state.user,
      //     token: action.payload
      //   }
      // }
      state.user = { ...state.user, token: action.payload };
    },
    updateUserData: (state, action) => {
      state.user.data = { ...state.user.data, ...action.payload };
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(api.endpoints.createAccount.matchFulfilled, (state, { payload }) => {
      state.user.data = payload;
    });
  },
});

export const { saveUser, updateUserToken, updateUserData, setLoading } = authSlice.actions;
export default authSlice.reducer;
